import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { localeSelector } from '../selectors/i18n';

const Footer = () => {
    const locale = useSelector(localeSelector);
    return (
        <footer>
            <div className="container">
                <div className="footer__content">
                    <div className="row">
                        <div className="col-lg-4 col-12 footer__1">
                            ©{new Date().getFullYear()} dăbilet.ro. <FormattedMessage id='all_rights_reserved'/>
                        </div>
                        <div className="col-lg-8 col-12 footer__2">
                            <a href={`/${locale}/show/termeni-si-conditii`} target="_blank" rel="noreferrer"><FormattedMessage id='terms'/></a>&nbsp; | &nbsp;
                            <a href={`/${locale}/show/purchase`} target="_blank" rel="noreferrer"><FormattedMessage id='purchase_policy'/></a>&nbsp; | &nbsp;
                            <a href={`/${locale}/show/cookie-policy`} target="_blank" rel="noreferrer"><FormattedMessage id='cookie_policy'/></a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
